import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import {
  Card,
  CardBody,
  Form,
  FormFeedback,
  Input,
  Label,
  Button,
  Spinner,
} from 'reactstrap';
import { useAppDispatch, useAuth, useIsForman } from '../../helpers/hooks';
import { login, clearError } from '../../slices/auth/authSlice';

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, error, isAuthenticated } = useAuth();
  const isForman = useIsForman();

  useEffect(() => {
    if (isAuthenticated) {
      // Forman users go to simplified interface
      if (isForman) {
        navigate('/forman');
      } else {
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, isForman, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Geçerli bir e-posta adresi giriniz')
        .required('E-posta adresi zorunludur'),
      password: Yup.string()
        .min(6, 'Şifre en az 6 karakter olmalıdır')
        .required('Şifre zorunludur'),
    }),
    onSubmit: (values) => {
      dispatch(login(values));
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Card>
          <CardBody className="p-4">
            <div className="auth-logo">
              <h4>Hoş Geldiniz</h4>
              <p>Sisteme giriş yapın</p>
            </div>

            <Form onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <Label htmlFor="email" className="form-label">
                  E-posta
                </Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="E-posta adresinizi giriniz"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.email && !!formik.errors.email}
                />
                {formik.touched.email && formik.errors.email && (
                  <FormFeedback>{formik.errors.email}</FormFeedback>
                )}
              </div>

              <div className="mb-3">
                <Label htmlFor="password" className="form-label">
                  Şifre
                </Label>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Şifrenizi giriniz"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.password && !!formik.errors.password}
                />
                {formik.touched.password && formik.errors.password && (
                  <FormFeedback>{formik.errors.password}</FormFeedback>
                )}
              </div>

              <div className="mt-4">
                <Button
                  color="primary"
                  className="w-100"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner size="sm" className="me-2" />
                  ) : null}
                  Giriş Yap
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default Login;
